const initTimelineWidget = () => {
    const imageToDragArray = document.querySelectorAll("[data-timeline-widget] [data-image-component]");
    imageToDragArray.forEach((image) => {
        let isDown = false;
        let startX;
        let scrollLeft;
        image.addEventListener("mousedown", e => {
            isDown = true;
            image.classList.add("active");
            startX = e.pageX - image.offsetLeft;
            scrollLeft = image.scrollLeft;
        });
        image.addEventListener("mouseleave", () => {
            isDown = false;
            image.classList.remove("active");
        });
        image.addEventListener("mouseup", () => {
            isDown = false;
            image.classList.remove("active");
        });
        image.addEventListener("mousemove", e => {
            if (!isDown)
                return;
            e.preventDefault();
            const x = e.pageX - image.offsetLeft;
            const walk = x - startX;
            image.scrollLeft = scrollLeft - walk;
        });
    });
};
